// @flow

export const APP = Object.freeze({
  LMS: 'lms',
  MARKET: 'market',
  USER: 'user',
  WIKI: 'wiki',
  ELEMENTARY: 'elementary',
  CONTENT_PAGE: 'content_page',
})
